import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, checkSessionExpiration, requiresPasswordChange } = useAuthStore();
  const location = useLocation();

  // Verificar expiración de sesión al cargar la ruta protegida
  useEffect(() => {
    checkSessionExpiration();
  }, [checkSessionExpiration]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si el usuario debe cambiar su contraseña, bloquear todas las rutas excepto la de cambio forzado
  if (requiresPasswordChange && location.pathname !== '/change-password-required') {
    return <Navigate to="/change-password-required" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
